import LoginBoard from './LoginBoard';

export * from './LoginBoard';
export default LoginBoard;
